import { httpRequest } from '../../../../app/common/util/api-common.util';

class ImunologiaAPI {
  static cancelamentoImuno(laudo, justificativa) {
    return httpRequest(`laudos/${laudo}/etapas/imuno/cancelamento`, 'PATCH', {
      justificativa: justificativa,
    }).then((json) => json.data);
  }
}

export default ImunologiaAPI;



// WEBPACK FOOTER //
// ./src/pages/laudo/etapas/imuno/imuno.api.js